module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"min":"Minimal value (optional)","max":"Maximal value (optional)"}},"de":{"label":{"min":"Minimalwert (optional)","max":"Maximalwert (optional)"}},"fr":{"label":{"min":"Valeur minimale (facultatif)","max":"Valeur maximale (facultatif)"}},"it":{"label":{"min":"Valore minimo (opzionale)","max":"Valore massimo (opzionale)"}}}')
  delete Component.options._Ctor
}
